import React from 'react';
import Hero from '../components/Hero/Hero';
import Features from '../components/Features/Features';
import Process from '../components/Process/Process';
import Universities from '../components/Universities/Universities';
import Stats from '../components/Stats/Stats';
import Testimonials from '../components/Testimonials/Testimonials';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import CallToAction from '../components/CallToAction/CallToAction';
import Programs from '../components/Programs/Programs';
import Contact from '../components/Contact/Contact';
import WorkProcess from '../components/WorkProcess/WorkProcess';
import Intakes from '../components/Intakes/Intakes';

const Home: React.FC = () => {
  return (
    <div className="bg-white">
      <Hero />
      <WorkProcess />
      <Intakes />
      <Features />
      <Process />
      <Universities />
      <Stats />
      <Testimonials />
      {/* <CallToAction /> */}
      <Programs />
      {/* <Contact /> */}
    </div>
  );
};

export default Home; 